import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';
import { environment } from 'src/environments/environment';

// declare var $:any;
@Component({
  selector: 'app-ant-media',
  templateUrl: './ant-media.component.html'
})
export class AntMediaComponent implements OnInit , AfterViewInit{
  @Input() auctionData: any
  @ViewChild('localVideo') localVideo!: ElementRef;

  webrtcAdaptor: any;


  // /* antmedia variable */
  token: any;
  pc_config: any = null;
  playStreamId: any;
  publishStreamId: any;
  sdpConstraintsPublish: any;
  mediaConstraintsPublish: any;
  publishWebRTCAdaptor: any;
  websocketURL!: string;
  room: any;
  showStream= false;
  closeStream=false;
  constructor() {
    
    this.websocketURL = environment.streamUrlPublish;
    this.webrtcAdaptor = null;
   

    // ant media
    this.token = "";
    this.pc_config =    
    {
      'iceServers': [{'urls': 'stun:stun1.l.google.com:19302'}]
  };

    //var path =  location.hostname + ":5443"+"/WebRTCAppEE/websocket";
    // let path = "phpmatrix.com:5443/WebRTCAppEE/websocket";

    // if (location.protocol.startsWith("https")) {
    //   this.websocketURL = "wss://" + path;
    // }
    console.log("websocketURL", this.websocketURL);

    this.sdpConstraintsPublish = {
      OfferToReceiveAudio: false,
      OfferToReceiveVideo: false
    };

    this.mediaConstraintsPublish = {
      video: true,
      audio: true
    };

  }

  ngOnInit(): void {
    this.room = this.auctionData.stream_id;
  }

  initWebrtc() {
    
    this.webrtcAdaptor = new WebRTCAdaptor({
      websocket_url: this.websocketURL,
      mediaConstraints: this.mediaConstraintsPublish,
      //peerconnection_config: null,
      sdp_constraints: this.sdpConstraintsPublish,
      localVideoId: "localVideo",
      peerconnection_config:{
        'iceServers': [{'urls': 'stun:stun1.l.google.com:19302'}]
      },
      bandwidth: 900,
      debug: true,
      isPlayMode: false,
      isShow: false,
      dataChannelEnabled: false,
      
      callback: (info: any, description: any) => {
        this.showStream = true;
        this.localVideo.nativeElement.play();
        console.log("Info: ", info);
        if (info == "initialized") {


        } else if (info == "publish_started") {
          //stream is being published
          console.log("publish started");
          // $('#publishBtn').attr('disabled', true);
          // $('#stopPublishBtn').attr('disabled', false);


        } else if (info == "publish_finished") {
          // $('#publishBtn').attr('disabled', false);
          // $('#stopPublishBtn').attr('disabled', true);
          //stream is being finished
          console.log("publish finished");
        } else if (info == "available_devices") {
          console.log("Calling available devices", description);
        } else if (info == "closed") {
          if (typeof description != "undefined") {
            this.webrtcAdaptor = null;
            this.initWebrtc();
            console.log("Connecton closed: " + JSON.stringify(description));
          }
        }
      },
      callbackError: (error: any, message: any) => {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError

        console.log("error callback: " + JSON.stringify(error));
        var errorMessage = JSON.stringify(error);
        if (typeof message != "undefined") {
          errorMessage = message;
        }
        var errorMessage = JSON.stringify(error);
        if (error.indexOf("NotFoundError") != -1) {
          errorMessage = "Camera or Mic are not found or not allowed in your device";
        }
        else if (error.indexOf("NotReadableError") != -1 || error.indexOf("TrackStartError") != -1) {
          errorMessage = "Camera or Mic is being used by some other process that does not let read the devices";
        }
        else if (error.indexOf("OverconstrainedError") != -1 || error.indexOf("ConstraintNotSatisfiedError") != -1) {
          errorMessage = "There is no device found that fits your video and audio constraints. You may change video and audio constraints"
        }
        else if (error.indexOf("NotAllowedError") != -1 || error.indexOf("PermissionDeniedError") != -1) {
          errorMessage = "You are not allowed to access camera and mic.";
        }
        else if (error.indexOf("TypeError") != -1) {
          errorMessage = "Video/Audio is required";
        }
        if (error.indexOf("publishTimeoutError") != -1) {
          console.log("publish timeout error caught, Correct Start stream label", error);
          this.webrtcAdaptor = null;
          this.initWebrtc();
        }

        //alert(errorMessage);
      }
    });
  }

  initStreaming(){
    this.initWebrtc();
    
  }

  PublishStreaming() {
    console.log(this.auctionData.stream_id);
    console.log(this.auctionData.stream_publish_token);
    
    this.webrtcAdaptor.publish(String(this.auctionData.stream_id),String(this.auctionData.stream_publish_token));
     this.localVideo.nativeElement.pause();
    this.closeStream = true;
  }

  StopPublishing() {
    this.webrtcAdaptor.stop(this.room);
    this.webrtcAdaptor.closeStream();
    this.localVideo.nativeElement.pause();
    this.closeStream = false;
    this.showStream = false;
  }
  ngAfterViewInit(): void {
    //this.initWebrtc();
  }
  // constructor() {
  //   this.websocketURL = "wss://ams.expertapps.com.sa:5443/LiveApp/websocket?target=origin";
  // }

  // ngOnInit(): void {
  // }

  // ngAfterViewInit(): void {
  //   const webRTCAdaptor = new WebRTCAdaptor({
  //     websocket_url: this.websocketURL, //this.auctionData.link_streaming,
  //     mediaConstraints: {
  //       video: true,
  //       audio: true,
  //     },
  //     peerconnection_config: {[ر]
  //       'iceServers': [{ 'urls': 'stun:stun1.l.google.com:19302' }]
  //     },
  //     sdp_constraints: {
  //       OfferToReceiveAudio: false,
  //       OfferToReceiveVideo: false,
  //     },
  //     localVideoId: "id-of-video-element", // `<video id="id-of-video-element" autoplay muted>``</video>`
  //   });
  // }
}
